import { Flex, Text } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const BigTagContainer = styled(Flex)<{
  bgColor: string
  borderColor: string
}>`
  background: ${({ bgColor }) => bgColor};
  border-radius: 8px;
  border: 1px solid ${({ borderColor }) => borderColor};
`

export const NoneUserSelectText = styled(Text)`
  user-select: none;
  -webkit-user-select: none;
`
